import * as Yup from 'yup';
import { REQUIRED_FIELD } from '../../../../../constants';

export const SpaceValidationSchema = Yup.object().shape({
  name: Yup.string().required(REQUIRED_FIELD),
  floorId: Yup.string().required(REQUIRED_FIELD),
  area: Yup.number().typeError('Total Area must be a number.').required(REQUIRED_FIELD),
});
